module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/img_example03-62bbff9fd8794a35c1f8b2e0aa023851.png";